import React from 'react';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import moment from 'moment';
import './style.css';

const HistoryPanel = ({
    selectedVersion,
    loadVersion,
    visibleHistory,
    isLoading,
    toast,
    setNodes,
    currentNode
}) => {
    const handleVersionSelect = (version) => {
        if (version.type === 'draft') {
            // For drafts, just load the version
            loadVersion(version);
        } else {
            // For published versions, check if there are unsaved changes
            const hasUnsavedChanges = currentNode && currentNode.data?.content !== version.nodes[0]?.data?.content;

            if (hasUnsavedChanges) {
                toast.current.show({
                    severity: 'warn',
                    summary: 'Unsaved Changes',
                    detail: 'You have unsaved changes. Do you want to discard them?',
                    life: 5000,
                    closable: true,
                    action: (options) => {
                        return (
                            <div className="flex gap-2">
                                <Button
                                    label="Discard"
                                    className="p-button-sm p-button-danger"
                                    onClick={() => {
                                        loadVersion(version);
                                        setNodes(version.nodes);
                                        options.hide();
                                    }}
                                />
                                <Button
                                    label="Keep"
                                    className="p-button-sm p-button-text"
                                    onClick={() => options.hide()}
                                />
                            </div>
                        );
                    }
                });
            } else {
                loadVersion(version);
                setNodes(version.nodes);
            }
        }
    };

    return (
        <div className="history-panel">
            <div className="history-header">
                <h3>Publish History</h3>
            </div>
            <div className="history-content">
                {isLoading ? (
                    <div className="loading-container">
                        <ProgressSpinner />
                        <span>Loading history...</span>
                    </div>
                ) : visibleHistory.length === 0 ? (
                    <div className="empty-history">
                        <i className="pi pi-history" style={{ fontSize: '2rem', marginBottom: '1rem' }}></i>
                        <span>No history available</span>
                    </div>
                ) : (
                    <div className="history-list">
                        {visibleHistory.map((item) => (
                            <div
                                key={`${item.id}-${item.type || (item.isDraft ? 'draft' : 'published')}-${item.updatedAt || ''}`}
                                className={`history-item ${!item.isEnabled ? 'disabled' : ''} ${selectedVersion?.id === item.id ? 'selected' : ''}`}
                                onClick={() => handleVersionSelect(item)}
                            >
                                <div className="history-item-content">
                                    <div className={'history-item-header'}>
                                        {/* <span className={`status-badge ${item.type} ${item.isEnabled ? 'enabled' : 'disabled'}`}>
                                            {item.type === 'draft' ? 'Draft' : item.isEnabled ? 'Published' : 'Disabled'}
                                        </span> */}
                                        <div className="history-item-title">
                                            <span>
                                                {item.changeType ? `Journey was ${item.changeType.toUpperCase()}` : `Update to ${item.id}`}
                                            </span>
                                        </div>
                                        <div className="history-item-date">
                                            {moment(item.updatedAt).format('MMM D, YYYY h:mm A')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default HistoryPanel; 